import addToCart from "./product-page/add-to-cart";
import productAccordion from "./product-page/product-page-accordion";
import productCarousels from "./product-page/product-page-carousels";
import productStats from "./product-page/product-stats";

document.addEventListener('DOMContentLoaded', () => {
  addToCart();
  productAccordion();
  productCarousels();
  productStats();
});